export const telemetryFeaturesList = [
    {
      title: "telemetryFeatures.eventsTimeline.title",
      description: "telemetryFeatures.eventsTimeline.description",
      imgUrl: "eventsTimeline",
      docsUrl: "telemetryFeatures.eventsTimeline.docsUrl"
    },
    {
      title: "telemetryFeatures.deepDive.title",
      description: "telemetryFeatures.deepDive.description",
      imgUrl: "deepDive",
      docsUrl: "telemetryFeatures.deepDive.docsUrl"
    },
    {
      title: "telemetryFeatures.notificationsAnywhere.title",
      description: "telemetryFeatures.notificationsAnywhere.description",
      imgUrl: "notificationsAnywhere",
      docsUrl: "telemetryFeatures.notificationsAnywhere.docsUrl"
    },
    {
      title: "telemetryFeatures.tailoredAlerts.title",
      description: "telemetryFeatures.tailoredAlerts.description",
      imgUrl: "tailoredAlerts",
      docsUrl: "telemetryFeatures.tailoredAlerts.docsUrl"
    }
  ];
  